module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "change-stat"
  }, [_c('h3', {
    staticClass: "change-stat__heading text--center"
  }, [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), _c('div', {
    staticClass: "change-stat__value"
  }, [_c('div', {
    staticClass: "font-condensed"
  }, [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), (_vm.direction == 'up') ? _c('div', {
    staticClass: "change-stat__direction--up"
  }) : _vm._e(), _vm._v(" "), (_vm.direction == 'down') ? _c('div', {
    staticClass: "change-stat__direction--down"
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf202f82","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/ChangeStat/ChangeStat.vue
// module id = 564
// module chunks = 1